import React from "react";
import { ParallaxBanner } from "react-scroll-parallax";
import Img from "gatsby-image/withIEPolyfill";

import SEO from "../components/seo";
import ServiceBox from "../components/serviceBox";

const sortFn = (a, b) => {
  return a.node.order - b.node.order;
}

const ServicesPage = ({data}) => {

  const servicesObj = data.allContentfulService.edges;
  const servicesSections = [
    servicesObj.filter(s => s.node.section === 1).sort(sortFn),
    servicesObj.filter(s => s.node.section === 2).sort(sortFn),
    servicesObj.filter(s => s.node.section === 3).sort(sortFn)
  ];

  const getText = key => {
    const arr = data.allContentfulTitle.edges;
    const node = arr.find(n => n.node.key === key);

    return node ? node.node.text.text : null;
  }
  
  return (
    <>
      <SEO title="Services" />

      <ParallaxBanner
        className="bg-ref-dark"
        style={{
          height: "70vh"
        }}
        layers={[
          {
            amount: -0.2,
            children: (
              <div className="parallax-children-20">
                <Img
                  fluid={data.histoire01.childImageSharp.fluid}
                  objectFit="cover"
                  objectPosition="50% 50%"
                  style={{ height: '100%' }}
                />
              </div>
            )
          }
        ]}
      >
        <div className="parallax-overlay overlay-black">
          <div className="wrapper wrapper-page-header">
            <div className="home-overlay-text">
              <h1>{getText('nos-services')}</h1>
            </div>
          </div>
        </div>
      </ParallaxBanner>

      <div className="wrapper section bg-ref-light">
        <h3>{getText('nos-services-header')}</h3>
        <h2>{getText('nos-services-section1')}</h2>
        <div className="service-box-container">
          {servicesSections[0].map((n, i) => (
            <ServiceBox
              key={'service-box-1-' + i}
              iconName={n.node.icon}
              title={n.node.title}
              description={n.node.description.description}
            />
          ))}
        </div>
        <h2>{getText('nos-services-section2')}</h2>
        <div className="service-box-container">
          {servicesSections[1].map((n, i) => (
            <ServiceBox
              key={'service-box-2-' + i}
              iconName={n.node.icon}
              title={n.node.title}
              description={n.node.description.description}
            />
          ))}
        </div>
        {/* <h2>{getText('nos-services-section3')}</h2>
        <div className="service-box-container">
          {servicesSections[2].map((n, i) => (
            <ServiceBox
              key={'service-box-3-' + i}
              iconName={n.node.icon}
              title={n.node.title}
              description={n.node.description.description}
            />
          ))}
        </div> */}
      </div>

      <ParallaxBanner
        className="bg-ref-dark"
        style={{
          height: "70vh"
        }}
        layers={[
          {
            amount: 0.2,
            children: (
              <div className="parallax-children-half-banner">
                <Img
                  fluid={data.tracteur01.childImageSharp.fluid}
                  objectFit="cover"
                  objectPosition="50% 50%"
                  style={{ height: '100%' }}
                />
              </div>
            )
          }
        ]}
      ></ParallaxBanner>

    </>
  );
}

export default ServicesPage;

export const query = graphql`
  query {
    histoire01: file(relativePath: { eq: "grange-01.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1500) {
          ...GatsbyImageSharpFluid_noBase64
        }
      }
    }
    tracteur01: file(relativePath: { eq: "tracteur-01.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1500) {
          ...GatsbyImageSharpFluid_noBase64
        }
      }
    }
    allContentfulTitle {
      edges {
        node {
          key
          text {
            text
          }
        }
      }
    }
    allContentfulService {
      edges {
        node {
          section
          order
          icon
          title
          description {
            description
          }
        }
      }
    }
  }
`;
